<template>
  <draggable
    :group="{ name: 'module', put: false, pull: 'clone' }"
    :sort="false"
    :value="childModules"
  >
    <div v-for="item in childModules" :key="item.id">
      <div
        class="module-block mb10"
        :style="`height:${height ? height : '132px'}`"
      >
        <div class="module-block-content">
          <div class="hover-content">
            <!-- <el-button size="mini" @click="addClick(item)">添加</el-button> -->
          </div>
          <div class="selected" v-if="ifSelected(item)">已选</div>
          <img :src="`${baseUrl}images/${item.code}1.jpg`" alt="" class="home-module-child-img">
        </div>

        <div class="module-tag">{{ item.name }}</div>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "homeC",
  components: { draggable },
  props: ['childModules','height', 'homeModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  created() {},
  computed: {},
  methods: {
    addClick(data){
      this.$emit('addClick', data)
    },
    ifSelected(val){
      return this.homeModules.some(item => item.cardType === val.code)
    }
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less">

</style>